import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Confetti from "react-confetti";
import { motion } from "framer-motion";
import axios from "../../api/axiosinstance";
import axiosInstance from "../../api/axiosinstance";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
  if (id) {
    trackPaymentSuccess();
  }
}, [id]);

const trackPaymentSuccess = async () => {
  try {
    await axiosInstance.post("/client-journey/track", {
      agreementId: id,

      step: "payment_success",

      page: window.location.pathname,

      description: "Client completed payment",
    });
  } catch (err) {
    console.log(err);
  }
};

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ================= DOWNLOAD INVOICE ================= */

  const handleDownloadInvoice = async () => {
    try {
      const response = await axios.get(`/payment/download-invoice/${id}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response]));

      const link = document.createElement("a");

      link.href = url;

      link.setAttribute("download", `invoice-${id}.pdf`);

      document.body.appendChild(link);

      link.click();

      link.remove();
    } catch (err) {
      console.log(err);

      alert("Invoice download failed");
    }
  };

  /* ================= DOWNLOAD AGREEMENT ================= */

  const handleDownloadAgreement = async () => {
    try {
      const response = await axios.get(`/service-agreement/download/${id}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response]));

      const link = document.createElement("a");

      link.href = url;

      link.setAttribute("download", `agreement-${id}.pdf`);

      document.body.appendChild(link);

      link.click();

      link.remove();
    } catch (err) {
      console.log(err);

      alert("Agreement download failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right,#f4f0ec,#fffdfb)",
        padding: "40px 20px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* CONFETTI */}

      <Confetti
        width={windowSize.width}
        height={windowSize.height}
        numberOfPieces={220}
        recycle={false}
      />

      <div
        style={{
          maxWidth: "1450px",
          margin: "0 auto",
          display: "flex",
          gap: "35px",
          alignItems: "flex-start",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* LEFT */}

        <motion.div
          initial={{
            x: -80,
            opacity: 0,
          }}
          animate={{
            x: 0,
            opacity: 1,
          }}
          transition={{
            duration: 0.7,
          }}
          style={{
            width: "340px",
            minWidth: "340px",
            background: "#5a140c",
            borderRadius: "30px",
            padding: "40px 32px",
            color: "#fff",
            position: "sticky",
            top: "20px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(90,20,12,0.25)",
          }}
        >
          {/* GLOW */}

          <div
            style={{
              position: "absolute",
              width: "240px",
              height: "240px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.05)",
              top: "-100px",
              right: "-100px",
            }}
          />

          <img
            src="/assets/img/whitelogo.png"
            alt=""
            style={{
              width: "130px",
              marginBottom: "35px",
            }}
          />

          <h1
            style={{
              fontSize: "42px",
              lineHeight: "54px",
              fontWeight: "700",
              marginBottom: "25px",
              color: "white",
            }}
          >
            PAYMENT
            <br />
            SUCCESS
          </h1>

          <div
            style={{
              width: "90px",
              height: "3px",
              background: "#fff",
              marginBottom: "35px",
            }}
          />

          <p
            style={{
              color: "rgba(255,255,255,0.82)",
              lineHeight: "32px",
              fontSize: "15px",
            }}
          >
            Your payment has been received successfully. Your agreement is now
            activated.
          </p>

          {/* STEPS */}

          <div
            style={{
              marginTop: "50px",
              display: "flex",
              flexDirection: "column",
              gap: "18px",
            }}
          >
            {["Agreement Reviewed", "OTP Verified", "Payment Completed"].map(
              (item, index) => (
                <motion.div
                  key={index}
                  initial={{
                    opacity: 0,
                    x: -30,
                  }}
                  animate={{
                    opacity: 1,
                    x: 0,
                  }}
                  transition={{
                    delay: 0.4 + index * 0.2,
                  }}
                  whileHover={{
                    scale: 1.03,
                  }}
                  style={{
                    background: "rgba(255,255,255,0.14)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    padding: "18px",
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    cursor: "pointer",
                  }}
                >
                  <motion.div
                    animate={{
                      scale: [1, 1.15, 1],
                    }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                    }}
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      background: "#fff",
                      color: "#5a140c",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "700",
                    }}
                  >
                    ✓
                  </motion.div>

                  <div>
                    <div
                      style={{
                        fontWeight: "700",
                      }}
                    >
                      {item}
                    </div>

                    <div
                      style={{
                        fontSize: "13px",
                        opacity: 0.75,
                      }}
                    >
                      Completed
                    </div>
                  </div>
                </motion.div>
              ),
            )}
          </div>
        </motion.div>

        {/* RIGHT */}

        <div
          style={{
            flex: 1,
          }}
        >
          {/* SUCCESS CARD */}

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 0.8,
            }}
            style={{
              background: "#fff",
              borderRadius: "30px",
              padding: "70px 40px",
              border: "1px solid #eaded8",
              textAlign: "center",
              marginBottom: "25px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 25px 80px rgba(0,0,0,0.05)",
            }}
          >
            {/* BG EFFECT */}

            <div
              style={{
                position: "absolute",
                width: "350px",
                height: "350px",
                borderRadius: "50%",
                background: "rgba(22,163,74,0.05)",
                top: "-180px",
                right: "-120px",
              }}
            />

            {/* SUCCESS ICON */}

            <motion.div
              initial={{
                scale: 0,
                rotate: -180,
              }}
              animate={{
                scale: 1,
                rotate: 0,
              }}
              transition={{
                type: "spring",
                stiffness: 120,
                damping: 10,
              }}
              style={{
                width: "140px",
                height: "140px",
                borderRadius: "50%",
                background: "#16a34a",
                margin: "0 auto 35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "70px",
                fontWeight: "700",
                boxShadow: "0 20px 50px rgba(22,163,74,0.35)",
                position: "relative",
                zIndex: 2,
              }}
            >
              <motion.span
                animate={{
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                }}
              >
                ✓
              </motion.span>
            </motion.div>

            {/* TITLE */}

            <motion.h1
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.4,
              }}
              style={{
                color: "#5a140c",
                fontSize: "68px",
                marginBottom: "10px",
                fontWeight: "800",
              }}
            >
              Thank You!
            </motion.h1>

            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                delay: 0.7,
              }}
              style={{
                color: "#c96f42",
                fontSize: "36px",
                fontWeight: "700",
                marginBottom: "30px",
              }}
            >
              Payment Successful
            </motion.div>

            <motion.p
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                delay: 1,
              }}
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                lineHeight: "38px",
                color: "#555",
                fontSize: "19px",
              }}
            >
              We have successfully received your payment. Your agreement has now
              been activated and our onboarding team will connect with you
              shortly.
            </motion.p>
          </motion.div>

          {/* BUTTONS */}

          <motion.div
            initial={{
              opacity: 0,
              y: 40,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 1.2,
            }}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,minmax(0,1fr))",
              gap: "20px",
            }}
          >
            {[
              {
                icon: "📥",
                title: "Download Invoice",
                desc: "Download payment receipt.",
                action: handleDownloadInvoice,
              },

              {
                icon: "🏠",
                title: "Back To Home",
                desc: "Return to homepage.",
                action: () => navigate("/"),
              },

              {
                icon: "📄",
                title: "Agreement Copy",
                desc: "Download agreement PDF.",
                action: handleDownloadAgreement,
              },
            ].map((item, index) => (
              <motion.button
                key={index}
                whileHover={{
                  y: -8,
                  scale: 1.02,
                }}
                whileTap={{
                  scale: 0.98,
                }}
                onClick={item.action}
                style={{
                  border: "1px solid #eaded8",
                  background: "#fffdfb",
                  borderRadius: "24px",
                  padding: "28px",
                  cursor: "pointer",
                  transition: "0.3s",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    fontSize: "42px",
                    marginBottom: "18px",
                  }}
                >
                  {item.icon}
                </div>

                <div
                  style={{
                    color: "#5a140c",
                    fontWeight: "700",
                    fontSize: "22px",
                    marginBottom: "8px",
                  }}
                >
                  {item.title}
                </div>

                <div
                  style={{
                    color: "#777",
                    lineHeight: "28px",
                  }}
                >
                  {item.desc}
                </div>
              </motion.button>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
